export const HOME = "/";
export const DESENGANCHE = "/Desenganche";
export const MENSUALIDADES = "/Mensualidades";
export const CONVENIOS = "/Convenios";
export const JURIDICAS = "/Pending";
export const LOGIN = "/admin";
export const REGISTRO = "/crearusuario";
export const ETHICSCHANNEL = "/ethicschannel";
export const BMANUAL = "/boleta";
export const SUPPORTDOC = "/supportdoc";
export const PDF = "/PDF";
export const CREDITNOTES = "/creditNotes";
export const FACTURACION = "/Facturacion";
export const PLANILLAS = "/Planillas";
export const AUDITORIA = "/Auditoria";
export const CLIENTES = "/Clientes";
export const PLANILLAS_MODIFICA_RECAUDO = "/Planillas/modificarecaudo";
export const PLANILLAS_CIERRE_DIA = "/Planillas/cierredia";
export const PLANILLAS_TRANSACCIONAL = "/Planillas/transaccional";
export const PLANILLAS_AJUSTE_FECHA = "/Planillas/ajuste-fecha";
export const PLANILLAS_TRASMITIR_GLOBAL = "/Planillas/trasmitir-global";
export const PLANILLAS_AJUSTE_MENSUALES = "/Planillas/ajuste-mensuales";
export const PLANILLAS_EFECTIVO_DATAFONO = "/Planillas/efectivo-datafono";
export const PLANILLAS_EDITAR_TURNO = "/Planillas/editarturno/:id";
export const PLANILLAS_EDITAR_DIA = "/Planillas/cierredia/:id";
export const PLANILLAS_EDITAR_DIA_ALT = "/Planillas/editarDia/:id";
export const PLANILLAS_EDITAR_TRANSACCIONAL = "/Planillas/transaccional/:id";
// Alias por compatibilidad con pantallas antiguas
export const PLANILLAS_CIERRE_TURNO = "/Planillas/modificarecaudo";

